import {create} from 'react-modal-promise';

import {ImageModal} from './index';

export const openImageModal = create(ImageModal);
